import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M480-120q-75 0-140-28t-114-77q-49-49-77-114t-29-141q0-75 29-140t77-114q48-49 114-77t140-29q82 0 156 35t124 99v-94h80v240H600v-80h110q-41-56-101-88t-129-32q-117 0-198 82t-82 198q0 117 82 199t198 81q105 0 184-68t92-172h82q-15 137-117 229t-241 91Zm112-192L440-464v-216h80v184l128 128-56 56Z"/>',
  f: '<path d="M480-120q-75 0-140-28t-114-77q-49-49-77-114t-29-141q0-75 29-140t77-114q48-49 114-77t140-29q82 0 156 35t124 99v-94h80v240H600v-80h110q-41-56-101-88t-129-32q-117 0-198 82t-82 198q0 117 82 199t198 81q105 0 184-68t92-172h82q-15 137-117 229t-241 91Zm112-192L440-464v-216h80v184l128 128-56 56Z"/>',
  rao: { fill: '#e8eaed' },
  raf: { fill: '#e8eaed' },
};

export default data;
